<template>
  <div class="cust-shadow bg-white rounded-12px px-5 mt-2 py-4">
    <div class="flex justify-between items-center">
      <div class="">
        <h2 class="text-black fsize14 gap-2 flex items-center font-bold">
          Recommended Upgrade

          <div
            v-tooltip.top="{
              content: 'Tailored to your needs and goals on the platform.',
              class: 'toolcust',
            }"
          >
            <feather-icon
              icon="InfoIcon"
              class="ml-1 text-grey flex cursor-pointer"
              svgClasses="w-5 h-5"
            />
          </div>
        </h2>
      </div>
      <div class="">
        <div
          class="flex justify-center bg-light-primary rounded-full items-center w-10 h-10"
        >
          <feather-icon
            icon="ChevronRightIcon"
            svgClasses="w-5 h-5"
            class="text-primary font-semibold flex cursor-pointer"
            @click="clickToAddons()"
          />
        </div>
      </div>
    </div>

    <div class="grid grid-cols-4 gap-4 mt-8 mb-4">
      <!-- Timer -->
      <!-- <div class="relative">
       
        <img
          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/u1.png"
          alt="icon"
        />
        <div class="absolute top-0 right-0">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/u1.png"
            alt="icon"
            class="w-6 h-6 mr-4"
          />
        </div>
      </div> -->
      <div class="relative" v-if="isWhatsapp">
        <!-- Whatsapp -->
        <img
          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/u2.png"
          alt="icon"
        />
        <div class="absolute top-0 right-0">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/u1.png"
            alt="icon"
            class="w-6 h-6 mr-4"
          />
        </div>
      </div>
      <div class="relative" v-if="isStorage == true">
        <!-- Storage -->
        <img
          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/u3.png"
          alt="icon"
        />
        <div class="absolute top-0 right-0">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/u1.png"
            alt="icon"
            class="w-6 h-6 mr-4"
          />
        </div>
      </div>
      <div class="relative" v-if="isSMS == true">
        <!-- @ -->
        <img
          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/u4.png"
          alt="icon"
        />
        <div class="absolute top-0 right-0">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/u1.png"
            alt="icon"
            class="w-6 h-6 mr-4"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      addOns: [],
      cards: [],
      isStorage: false,
      isWhatsapp: false,
      isSMS: false,
    };
  },
  methods: {
    clickToAddons() {
      this.$router.push({ name: "Add-ons" });
    },
    async getAddOnsDetails() {
      let payload = {
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch("projectFile/getAddOns", payload);
      console.log(data.data.data, "addOns");
      this.addOns = data.data.data;
    },
    async getAddOnsUsageDetails() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "projectFile/getAddOnsUsageDetails",
        payload
      );
      console.log(data.data, "addOns");
      this.cards = data.data;
      for (let i of this.cards) {
        // console.log(i.addonId.name, "addonsss");
        if (i.addOnId.flag == "CG" && i.quantity / 1024 / 1024 < 3) {
          this.isStorage = true;
        }
        if (i.addOnId.flag == "T_SMS" && i.quantity < 500) {
          this.isSMS = true;
        }
        if ((i.addOnId.flag = "WA" && i.quantity < 200)) {
          this.isWhatsapp = true;
        }
      }
    },
  },
  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("projectFile", ["selectedProjectDetails"]),
  },
  async mounted() {
    // await this.getAddOnsDetails();
    await this.getAddOnsUsageDetails();
  },
};
</script>
